import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'bookexpress';

  constructor(private router: Router) {
    console.log('AppComponent cconstructor');
    sessionStorage.setItem('ADMIN-Sessionlogin', JSON.stringify(new Date().getTime()));
    const ga4Data = !!window.sessionStorage.getItem('GA4Data') && JSON.parse(window.sessionStorage.getItem('GA4Data'));

    // Detecting the route change
    if (!!ga4Data && (!!ga4Data?.gaAgilysysId || !!ga4Data?.gaCustomerId)) {
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: Partial<NavigationEnd> | any) => {
        if (window['ga']) {
          window['ga']('event', 'page_view', {
            page_path: event.urlAfterRedirects,
          });
        }
      });
    }
  }
}
